import { RightLevel } from '../models/RightLevel.enum';
import { RightWithLevel } from '../models/rightWithLevel.model';
import { Right } from '../models/Rights.enum';

const right = Right;

export class UserRights {
    private coordinates: RightLevel;
    private cart: RightLevel;
    private payment: RightLevel;
    private accountExtract: RightLevel;
    private signature: RightLevel;

    constructor(coordinates: RightLevel,
        cart: RightLevel,
        payment: RightLevel,
        accountExtract: RightLevel,
        signature: RightLevel) {
            this.coordinates = coordinates;
            this.cart = cart;
            this.payment = payment;
            this.accountExtract = accountExtract;
            this.signature = signature;
    }

    public get Coordinates(): RightLevel { return this.coordinates; }
    public get Cart(): RightLevel { return this.cart; }
    public get Payment(): RightLevel { return this.payment; }
    public get AccountExtract(): RightLevel { return this.AccountExtract; }
    public get Signature(): RightLevel { return this.signature; }
    public get Rights(): Array<RightWithLevel> {
        return [{Right: Right.Coordinates, RightLevel: this.coordinates},
                {Right: Right.Cart, RightLevel: this.cart},
                {Right: Right.Payment, RightLevel: this.payment},
                {Right: Right.AccountExtract, RightLevel: this.accountExtract},
                {Right: Right.Signature, RightLevel: this.signature}];
    }
    public get RightsAsDictionnary(): { [id: string]: RightLevel } {
        const dictionnary: { [id: string]: RightLevel } = {};

        dictionnary[right[right.Coordinates]] = this.coordinates;
        dictionnary[right[right.Cart]] = this.cart;
        dictionnary[right[right.Payment]] = this.payment;
        dictionnary[right[right.AccountExtract]] = this.accountExtract;
        dictionnary[right[right.Signature]] = this.signature;

        return dictionnary;
    }
}
